export default __webpack_public_path__ + "static/media/linkIcon.9b39f382.svg";